import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import HomeScreen from "./components/HomeScreen";
import AddScreen from "./components/AddScreen";
import PrivateRoute from "./components/PrivateRoute";
import ReciepesList from "./components/ReciepesList";
import ReceipeScreen from "./components/ReceipeScreen";
import PuzzleGame from "./components/PuzzleGame";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/game" component={PuzzleGame} />
        <Route path="/login" component={Login} />
        <PrivateRoute path="/add" admin={false} component={AddScreen} />
        <Route path="/receipe/:id" admin={false} component={ReceipeScreen} />
        <PrivateRoute path="/receipe" admin={true} component={ReciepesList} />
        <Route exact path="/" component={HomeScreen} />
      </Switch>
    </Router>
  );
}

export default App;
